export default {
  "setting.loginas":"にログイン",

  "setting.account.pwValidityPeriod": "パスワード有効期間",
  "setting.onlineSale.addReserve": "予定を追加",

  "setting.global.subTitle":"ブランドアカウント設定",
  "setting.global.sendInterval":"チケットメール再送間隔(秒)",
  "setting.global.resendcount":"チケットメール再送回数",
  "setting.global.emailcount":"チケットメール枚数（枚/回）",
  "setting.global.placeholder": "例）20",
  "setting.ticketType": "券種カテゴリー",
  "setting.global.sendEmailWait.required": "チケットメール再送間隔を入力してください",
  "setting.global.sendEmailRetryCount.required": "チケットメール再送回数を入力してください",
  "setting.global.sendEmailTotal.required": "チケットメール枚数を入力してください",
  "setting.global.ticketName.required": "券種カテゴリー名前を入力してください",

  "setting.emergency.stoptime":"販売停止時間（開始時間）",
  "setting.emergency.p.stoptime":"日付を選択してください",
  "setting.emergency.restarttime":"販売停止時間（終了時間）",

  "setting.emergency.area":"エリア",
  "setting.emergency.perfecture":"都道府県",
  "setting.emergency.municipal":"区町村",

  "setting.emergency.ippermit":"アクセス許可（IPアドレス）",
  "setting.emergency.p.ippermit":"例）127.0.0.1",

  "setting.emergency.stoprec":"ネット予約停止予定/記録",

  "setting.emergency.msg.err.stop":"販売停止時間（終了時間）を選んでください",
  "setting.emergency.msg.err.start":"販売停止時間（開始時間）を選んでください",
  "setting.emergency.msg.err.disputetime":"開始時間が終了時間より遅く設定されています。開始時間を終了時間より早く設定してください",
  "setting.emergency.msg.err.cinema":"劇場が設定されていません。劇場を選んでください",

  "setting.pay.edit.title":"決済方法登録 / 修正",
  "setting.pay.accgroup":"帳票表示",
  "setting.pay.p.accgroup":"選択してください",
  "setting.pay.alert.msg1":"入力してください",
  "setting.pay.nameshow":"表示名",
  "setting.pay.p.nameshow": "入力してください",
  "setting.pay.paygroup":"決済種類",
  "setting.pay.p.paygroup": "選択してください",
  "setting.pay.type.gmo": "GMO PG",
  "setting.pay.type.cash": "現金",
  "setting.pay.type.creditCard": "クレジット（非連携）",
  "setting.pay.type.cash380": "現金（Glory 380シリーズ）",
  "setting.pay.type.creditCard3000": "クレジット（VEGA 3000）",
  "setting.pay.fee.amount": "カード手数料",
  "setting.pay.fee.transmethod": "カード手数料",
  "setting.pay.fee.transmethod.suffix": "計算方法",
  "setting.pay.fee.tax":"消費税（カード手数料）",
  "setting.pay.fee.client": "取引先（カード手数料）",
  "setting.pay.mod.single": "取引ごとで計算",
  "setting.pay.mod.month": "月割計算",
  "setting.pay.fee.destcode": "仕向先会社コード",
  "setting.pay.fee.destcode2": "KID",
  "setting.pay.process.fee": "売上処理料 / トランザクション処理料",
  "setting.pay.process.transmethod":"売上処理料 / トランザクション処理料計算方法",
  "setting.pay.process.tax": "消費税（売上処理料 / トランザクション処理料）",
  "setting.pay.process.client":"取引先（売上処理料 / トランザクション処理料）",
  "setting.pay.system.fee":"システム利用料（月割計算）",
  "setting.pay.system.tax":"消費税（システム利用料）",
  "setting.pay.system.client":"取引先（システム利用料）",
  "setting.pay.gmospec": "GMO PGシステム設定",
  "setting.pay.gmospec.id": "ショップID",
  "setting.pay.gmospec.auth": "シークレットキー",
  "setting.pay.gmospec.tooltip": "提供される情報は暗号化されます",
  "setting.pay.typ2.option1": "クレジットカード（非連携） ",
  "setting.pay.typ2.option2": "商品券（非連携） ",
  "setting.pay.typ2.option3": "電子マネー（非連携）",

  "setting.device.grouptab.ticket":"券種",
  "setting.device.grouptab.consession":"コンセッション",
  "setting.device.grouptab.commercial":"物販",
  "setting.device.grouptab.set":"セット",
  "setting.device.grouptab.coupon":"優待券",

  "setting.device.id":"ID",
  "setting.device.devicetype":"デバイス種類",
  "setting.device.createtime":"時間",

  "setting.device.devicecoop":"デバイス連携",
  "setting.device.button.reset":"リセット",
  "setting.device.button.refresh":"再読み込み",
  "setting.device.pay.methods":"支払い方法",
  "setting.device.shownas":"表示",
  "setting.device.paymntmethod":"決済方法",
  "setting.device.paymntName":"表示名",
  "setting.device.acc.rules":"帳票表示ルール",
  "setting.device.followaction":"連携アクション",
  "setting.device.dialog.otp":"（こちらのワンタイムパスワードをPOSアプリに入力してください）",
  "setting.device.cc380": "自動釣銭機端末（Glory 380シリーズ）設定",
  "setting.device.dialog.ipAddress": "送信先 IP アドレス",
  "setting.device.dialog.ipAddress.p": "端末IPアドレスを入力してください",
  "setting.device.dialog.device380": "デバイスID",
  "setting.device.dialog.device380.p": "デバイスIDを入力してください",
  "setting.device.cc3000": "クレジット端末（VEGA 3000）設定",
  "setting.device.dialog.port":"送信ポート番号",
  "setting.device.dialog.port.p":"ポートを入力してください",
  "setting.device.dialog.serverport": "受信ポート番号",

  "setting.device.warn.orderrequire":"順番を入力してください",
  "setting.kitchenPrinterDevice.title": "デバイス設定",
  "setting.kitchenPrinterDevice.sn": "シリアルコード",
  "setting.kitchenPrinterDevice.printCount": "印刷回数",
  "setting.kitchenPrinterDevice.deviceType": "デバイス種類",
  "setting.kitchenPrinterDevice.printPause": "プリント一時停止",
  "setting.kitchenPrinterDevice.printResume": "プリント再開",
  "setting.kitchenPrinterDevice.plsInputName": "名前を入力してください",
  "setting.kitchenPrinterDevice.plsInputSN": "シリアルコードを入力してください",

  "setting.customDisplay.title": "コンセ受け取りサイネージ",

  "setting.brand.companyinfo":"会社基本情報",
  "setting.brand.basic":"会計基本設定",
  "setting.brand.account":"ブランドアカウント設定",
  "setting.brand.new":"ブランド作成",
  "setting.brand.edit":"ブランド編集",

  "setting.brand.account.passconfirm":"パスワード確認",
  "setting.brand.p.email":"例) eigataro@eigaland.com",
  "setting.brand.err.password.notmatch":"入力したパスワードが間違っています",

  "setting.brand.businesscode":"事業者コード",
  "setting.brand.p.businesscode":"例) 001",
  "setting.brand.fraction":"1円未満の端数処理（取引）",
  "setting.brand.fraction2": "1円未満の端数処理（消費税）",
  "setting.brand.franction.truncate": "切捨て",
  "setting.brand.franction.roundup": "切上げ",
  "setting.brand.franction.rounding": "四捨五入",
  "setting.brand.accountsReceivableCycle":"売掛金入金サイクル（請求締日の属する月の）",
  "setting.brand.monthafter": "月後の",
  "setting.brand.end":"末",
  "setting.brand.beforeHoliday":"祝休日前",
  "setting.brand.afterHoliday":"祝休日後",
  "setting.brand.publicweek":"公開週のリセット日数",
  "setting.brand.p.publicweek":"例) 14",
  "setting.brand.err.publicwek":"公開週のリセット日数を入力してください",
  "setting.brand.bizname":"事業者名",
  "setting.brand.p.bizname":"事業者名を入力してください",
  "setting.brand.postalcode":"郵便番号",
  "setting.brand.p.postalcode":"例) 123-4567",
  "setting.brand.p.area":"エリアを検索してください",
  "setting.brand.p.perfecture":"都道府県を検索してください",
  "setting.brand.p.city":"例) 中央区",
  "setting.brand.example.address1":"（市区町村以下〜番地）",
  "setting.brand.p.address1":"例) 日本橋〇-〇-〇",
  "setting.brand.example.address2":"（建物名〜号室）",
  "setting.brand.p.address2":"例) 〇〇ビル　〇〇〇号室",
  "setting.brand.tel":"電話番号",
  "setting.brand.p.fax":"例) 030-0000-0000",
  "setting.brand.fax":"FAX番号",
  "setting.brand.since":"設立",
  "setting.brand.p.since":"例) 2015年",
  "setting.brand.bizcontent":"事業内容",
  "setting.brand.p.bizcontent":"例) 映画館運営",
  "setting.brand.bizcapital":"資本金",
  "setting.brand.p.bizcapital":"例) 〇〇〇〇円",
  "setting.brand.representative":"代表者",
  "setting.brand.p.representative":"例) 映画太郎",
  "setting.brand.cropstamp":"法人角印画像",
  "setting.brand.croplogo":"ロゴ画像",
  "setting.brand.ttcgcode":"ブランドコード（映画ランド用）",
  "setting.brand.p.ttcgcode":"例) EGL",
  "setting.brand.brandStamp":"会社印",

  "setting.cinema.city":"市区町村",
  "setting.cinema.online":"オンライン予約関連設定",
  "setting.cinema.displayLoginScreen": "オンライン予約会員ログイン画面の表示",
  "setting.cinema.ticketsales":"チケット販売関連設定",
  "setting.cinema.trailer": "待機時の予告編と写真表示設定（自動券売機）",
  "setting.device.trailer": "待機時の予告編と写真表示設定（コンセセルフレジ）",
  "setting.cinema.admission":"入場関連設定",
  "setting.cinema.linkage":"システム連携設定",
  "setting.cinema.tmsSetting":"TMS連携設定",
  "setting.cinema.tmsCinemaServer":"シネマサーバー",
  "setting.cinema.accounts":"シネマアカウント設定",
  "setting.cinema.new":"劇場作成",
  "setting.cinema.edit":"劇場編集",
  "setting.cinema.code":"劇場コード（編集禁止）",
  "setting.cinema.ttcgcode":"劇場コード（映画ランド用）",
  "setting.cinema.err.code":"劇場コードを入力してください",
  "setting.cinema.err.status":"ステータスを検索してください",
  "setting.cinema.status.preopen":"開業前",
  "setting.cinema.status.close":"閉館",
  "setting.cinema.status.rest":"休業中",
  "setting.cinema.status.open":"営業中",
  "setting.cinema.trailer.use": "利用する",
  "setting.cinema.trailer.waitTime": "操作待機時間（秒）",
  "setting.cinema.trailer.type": "種類",
  "setting.cinema.trailer.option1": "予告編",
  "setting.cinema.trailer.option2": "写真",
  "setting.cinema.trailer.link": "予告編リンク",
  "setting.cinema.trailer.link.p": "入力してください",
  "setting.cinema.trailer.displaytime": "表示時間（秒）",

  "setting.cinema.entrance.start":"スキャン可能開始*時刻*（分）",
  "setting.cinema.p.minutes":"例) 120",
  "setting.cinema.entrance.end":"スキャン可能終了*時刻*（分）",
  "setting.cinema.entrance.err.start":"スキャン可能開始*時刻*（分）を入力してください",
  "setting.cinema.entrance.err.end":"スキャン可能終了*時刻*（分）を入力してください",

  "setting.cinema.ticket.boxend":"BOX販売終了時間（上映時間〇〇分後）",
  "setting.cinema.p.minutes.30":"例）30",
  "setting.cinema.ticket.onlineend":"ネット予約終了時間（上映時間〇〇分前）",
  "setting.cinema.p.minutes.10":"例）10",
  "setting.cinema.ticket.boxstart":"窓口販売開始日（上映日の〇〇日前）",
  "setting.cinema.p.days.2":"例）2",
  "setting.cinema.ticket.onlinestart":"ネット予約開始日（上映日の〇〇日前）",
  "setting.cinema.plsEnterClosingTime": "日閉め時間（時、36時間制）を入力してください",
  "setting.cinema.closingTimeMax": "0-36の間の数字を記入してください",
  "setting.cinema.ticket.closehour":"営業日締め時間（36時間制、翌日12:00＝36時）",
  "setting.cinema.p.hours.00":"例) 00",
  "setting.cinema.ticket.boxmax":"最大購入席数（BOX）",
  "setting.cinema.ticket.onlinemax":"最大購入席数（ネット）",

  "setting.cinema.pay.payment.shopid":"オンライン決済ショップID（13桁）（編集禁止）",
  "setting.cinema.pay.payment.p.shopid":"例) 9100123456790",
  "setting.cinema.pay.payment.password":"オンライン決済パスワード（編集禁止）",
  "setting.cinema.pay.email":"送信メールアドレス（編集禁止）",
  "setting.cinema.pay.emailpassword":"送信メールパスワード（編集禁止）",
  "setting.cinema.pay.err.shopid":"オンライン決済ショップIDを入力してください",
  "setting.cinema.pay.err.password":"オンライン決済パスワードを入力してください",
  "setting.cinema.pay.err.email":"チケット送信メールアドレスを入力してください",
  "setting.cinema.pay.err.emailpassword":"チケット送信メールパスワードを入力してください",
  "setting.cinema.pay.err.refreshToken": "リフレッシュトークンを入力してください",

  "setting.cinema.olduuid":"旧チケッティング劇場ID",
  "setting.cinema.p.olduuid":"旧チケッティング劇場IDを入力してください",
  "setting.cinema.owner":"支配人",
  "setting.cinema.p.owner":"例) 映画太郎",
  "setting.cinema.owernstamp":"支配人印",
  "setting.cinema.businesshours":"営業時間",
  "setting.cinema.p.businesshours":"例) 月〜日　10:00~21:00　休日：年末年始",
  "setting.cinema.twitter":"Twitter",
  "setting.cinema.p.twitter":"例) https://twitter.com/eigaland",
  "setting.cinema.instagram":"Instagram",
  "setting.cinema.p.instagram":"例) https://www.instagram.com/eigaland/",
  "setting.cinema.facebook":"Facebook",
  "setting.cinema.p.facebook":"例) https://www.facebook.com/eigaland/",
  "setting.cinema.copywrite":"コピーライト",
  "setting.cinema.p.copywrite":"例) ©映画ランド️",
  "setting.cinema.intro":"紹介文",
  "setting.cinema.p.intro": "劇場紹介文を入力してください",

  "setting.cinema.plsEnterPostalCode": "郵便番号を入力してください",
  "setting.cinema.plsEnterRegion": "エリアを選択してください",
  "setting.cinema.plsEnterPrefecture": "都道府県を選択してください",
  "setting.cinema.plsEnterCity": "市区町村を入力してください",
  "setting.cinema.plsEnterAddress1": "住所1を入力してください",
  "setting.cinema.plsSelectPicFirst": "注意：削除する画像を先に選択し、削除ボタンを押してください",
  "setting.cinema.standByImage": "POSカスタマーディスプレイ待機画像(1080 x 1980, 縦)",

  "setting.cinema.jointSetting": "ムビチケ連携設定",
  "setting.cinema.websiteCode": "サイトコード（編集禁止）",
  "setting.cinema.p.websiteCode": "例) 120",

  "setting.cinema.openAPIjointInfo": "劇場Open API連携情報",
  "setting.cinema.openAPIjointInfo.sub1": "Bearer Token",
  "setting.cinema.openAPIjointInfo.sub2": "Cinema ID",
  "setting.cinema.openAPIjointInfo.sub3": "Web Key",
  "setting.cinema.openAPIjointInfo.sub4": "Signage Key",
  "setting.cinema.openAPIjointInfo.sub5": "Website Domain",

  "setting.brand.taxHandling": "消費税経理処理",
  "setting.brand.taxHandlingOptions1": "税抜経理",
  "setting.brand.taxHandlingOptions2": "税込経理",
  "setting.brand.taxHandlingOptions3": "免税",

  "setting.device.numOfReceiptsPrinted": "レシート印刷数",
  "setting.device.numOfTicketPrinted": "チケット印刷数",

  "setting.cinema.accessToken": "アクセストークン",
  "setting.cinema.refreshToken": "リフレッシュトークン",
};
